import { bigSpacing, reallyBigSpacing } from '../enums/Spacings'
import Box from './Box'
import ErrorBoundarySuggestions from './ErrorBoundarySuggestions'
import GrooverText from './GrooverText'
import { Layout } from './Layout'

export default function ErrorBoundaryView() {
  return (
    <Layout>
      <Box fullWidth fullPadding align="center" spacing={bigSpacing} fullHeight>
        <Box top spacing={reallyBigSpacing}>
          {'A wonderful Logo tp be creatd by our lovely Product Owner'}
        </Box>
        <Box top>
          <GrooverText textKey="errorBoundaryTitle" style={{ color: 'white' }} />
        </Box>
        <Box top>
          <GrooverText textKey="errorBoundaryDescription" style={{ color: 'rgba(255,255,255,0.7)' }} />
        </Box>
        <ErrorBoundarySuggestions />
      </Box>
    </Layout>
  )
}
